import { Grid, Link, Typography } from "@mui/material";
import React from "react";
// import logo from "../assests/images/logoSuenos.jpeg";
import logo_bahiense from "../assests/images/logo_bahiense_50.jpeg";
import logo_LOU from "../assests/images/logo_LOU.jpeg";
export default function Footer() {
  const images = [logo_bahiense, logo_LOU];
  return (
    <>
      <Grid container spacing={2}>
        {images.map((imagen, index) => (
          <Grid key={index} item xs={12} sm={6} sx={{ textAlign: "center" }}>
            <img
              src={imagen}
              alt={`Imagen ${index + 1}`}
              style={{ height: 200 }}
            />
          </Grid>
        ))}
      </Grid>
      <Typography sx={{ textAlign: "center" }}>
        Power By{" "}
        <Link
          href="https://tench-arg.web.app/"
          target="_blank"
          sx={{ color: "black" }}
        >
          Tench
        </Link>
      </Typography>
    </>
  );
}
